import { NgModule } from '@angular/core';
import { PrasadAngularComponent } from './prasad-angular.component';



@NgModule({
  declarations: [PrasadAngularComponent],
  imports: [
  ],
  exports: [PrasadAngularComponent]
})
export class PrasadAngularModule { }
